import React, { Component } from 'react';
import { IonButton, IonIcon, IonInput, IonItem } from '@ionic/react';
import { getConfig } from '../../appConfig';
import Mobiscroll from '../../components/mobiscroll';
import './index.css';
import { withTranslation } from '../../lib/translate';
import { isWebConfig } from '../../lib/utils';
import { FieldError } from '../common';
const { SelectOption } = Mobiscroll;
import wrong from '../../assets/images/Deli_Wrong.svg';
import { chevronDownOutline } from 'ionicons/icons';

class MobileInput extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			mobile_code: '',
			mobile_value: '',
		};
	}

	render() {
		const { __, mobile_code, mobile_value, setMobileCode, setMobileValue, className, error } = this.props;
		const countryCodeData = getConfig().country_code_data || [
			{
				text: 'GB +44',
				value: '+44',
			},
			{
				text: 'US +1',
				value: '+1',
			},
		];

		return (
			<>
				<IonItem lines="none" className={`${error ? 'input-field-wrapper-invalid' : ''} input-field-wrapper-large input-field-wrapper inline-input-field-wrapper ${className ? className : ''}`}>
					<div className="mobile-code-selection">
						<SelectOption
							theme='ios'
							cssClass={`mobile-code-filter ${isWebConfig() ? 'web' : ''}`}
							filter={true}
							onSet={(e, val) => setMobileCode(val.getVal())}
							display="center"
							value={mobile_code || countryCodeData[0].value}
							data={countryCodeData}
							onInit={(e, val) => {
								if (!mobile_code) {
									setMobileCode(countryCodeData[0].value);
								}
							}}
							cancelText={__('Cancel')}
							setText={__('Set')}
							filterPlaceholderText={__('Search')}
							height={60}
							wheelSize={3}
						/>
						<IonIcon icon={chevronDownOutline} />

					</div>
					<IonInput
						onIonInput={(e) => setMobileValue(e.target.value.replace(/^0+/, ''))}
						required={false}
						type="tel"
						pattern="tel"
						inputmode="tel"
						placeholder={__('Mobile number')}
						value={mobile_value}
						className='mobile-value-input'
					></IonInput>
					{error &&
						<IonButton className='input-validator-button' fill='clear' size="small" style={{ display: 'grid' }}>
							<IonIcon slot="icon-only" icon={wrong} />
						</IonButton>
					}

				</IonItem>
				{error && <FieldError className="field-error" value={__(error)} />}

			</>
		);
	}
}

export default withTranslation(MobileInput);
